
	jQuery(function ($) {

        var hashTabName = $(location).attr('hash');
        console.log('hash: '+hashTabName);


        if (hashTabName) {
          $('#nav-tab li button.active').removeClass('active');
          $('#nav-tabContent .tab-pane.active.show').removeClass('active').removeClass('show');

          $('#nav-tab '+hashTabName+'-tab').addClass('active');
          $('#nav-tabContent '+hashTabName).addClass('active').addClass('show');
        }
        else {
                  
          $('#nav-tab li:nth-child(1) > button').addClass('active');
          $('#nav-tabContent .tab-pane:nth-child(1)').addClass('active').addClass('show');
  
          }
  


        $('#whatsnew li:nth-child(1) > button').addClass('active');
        $('#news-sectionContent .tab-pane:nth-child(1)').addClass('active').addClass('show');



        $('#facilities-section li:nth-child(2) > button').addClass('active');
        $('#senshin-section li:nth-child(1) > button').tab('show');
   //     $('#wrapper-single-activity #nav-tab li:first-child > button').tab('show');

        $('ul.dropdown-menu [data-toggle=dropdown]').on('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          $(this).parent().siblings().removeClass('show');
          $(this).parent().toggleClass('show');
          $(this).next().toggleClass('show');
        });
        jQuery(function () {
          $(window).width();
          var headerHight = 108;
          jQuery('a[href^=#]:not(.dropdown-toggle, .nav-link)').click(function () {
            var speed = 1000;
            var href = jQuery(this).attr("href");
            var target = jQuery(href == "#" || href == "" ? 'html' : href);
            var position = target.offset().top - headerHight;
            jQuery('body,html').animate({
              scrollTop: position
            }, speed, 'swing');
            return false;
          });
        });

/*        $('.link-tab').click(function () {
          var hashTabName = $(this).attr('href');
          $('#nav-tab a[href=' + hashTabName + ']').tab('show');
        });


        var hashTabName = document.location.hash;
        if (hashTabName) {
          $('#nav-tab a[href=' + hashTabName + ']').tab('show');
        }
  */

        $(function () {
          $('.noclick').attr('onmousedown', 'return false');
          $('.noclick').attr('onselectstart', 'return false');
          $('.noclick').attr('oncontextmenu', 'return false');
        });






      });